/**
 * 資料 5 テーマのメタ情報。CSS は documentThemes.css 側で `[data-doc-theme]` セレクタで上書き。
 */
import type { DocumentTheme } from '@goenhub/shared';

export const DOCUMENT_THEMES: DocumentTheme[] = [
  'light',
  'dark',
  'vibrant',
  'pastel',
  'editorial',
];

export const THEME_LABEL: Record<DocumentTheme, string> = {
  light: 'ライト',
  dark: 'ダーク',
  vibrant: 'バイブラント',
  pastel: 'パステル',
  editorial: 'エディトリアル',
};

export const THEME_DESCRIPTION: Record<DocumentTheme, string> = {
  light: '白背景 × 黒テキスト。読みやすさ重視のクラシック。',
  dark: '黒背景 × 白テキスト。スタイリッシュで高級感。',
  vibrant: '深紫 × ピンクアクセント。テック・SaaS 向け。',
  pastel: 'ベージュ × オレンジ。あたたかみのあるブランド向け。',
  editorial: 'オフホワイト × セリフ書体。雑誌・出版風。',
};

/** プレビュー時の代表色 (左：背景、右：アクセント) */
export const THEME_SWATCH: Record<DocumentTheme, { bg: string; accent: string; text: string }> =
  {
    light: { bg: '#ffffff', accent: '#0a0a0a', text: '#0a0a0a' },
    dark: { bg: '#0b0d10', accent: '#7cffb2', text: '#f5f5f5' },
    vibrant: { bg: '#0e0524', accent: '#ff4d8d', text: '#ffffff' },
    pastel: { bg: '#faf4ee', accent: '#e07856', text: '#3a2a1f' },
    editorial: { bg: '#f8f5ee', accent: '#1a1a1a', text: '#1a1a1a' },
  };
